'use client';

import * as React from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';

import { Button } from '@workspace/ui/components/button';

export type QuantitySelectorProps = {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  label?: string;
};

export function QuantitySelector({
  value,
  onChange,
  min = 1,
  max = 10,
  label = 'Quantity'
}: QuantitySelectorProps): React.JSX.Element {
  return (
    <div className="flex flex-col items-center gap-2">
      <span className="text-sm font-medium text-muted-foreground">{label}</span>
      <div className="flex items-center gap-1 rounded-full bg-muted p-1">
        <Button
          variant="ghost"
          size="icon"
          aria-label="Decrease quantity"
          className="h-8 w-8 rounded-full"
          disabled={value <= min}
          onClick={() => onChange(Math.max(min, value - 1))}
        >
          <MinusIcon className="h-4 w-4" />
        </Button>
        <span className="min-w-[2ch] text-center text-lg font-semibold tabular-nums">
          {value}
        </span>
        <Button
          variant="ghost"
          size="icon"
          aria-label="Increase quantity"
          className="h-8 w-8 rounded-full"
          disabled={value >= max}
          onClick={() => onChange(Math.min(max, value + 1))}
        >
          <PlusIcon className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
